module.exports = __webpack_public_path__ + "media/images/color_admin_v3/login-bg/bg-3-6318a63bcbe60fb7cbad2c96ad2a50e6.jpg";